import React from 'react';

import { ErrorBoundary } from './errorBoundary';

export const withErrorBoundary = (Component: React.ComponentType<any>) => (props: any) => (
  <ErrorBoundary>
    <Component {...props} />
  </ErrorBoundary>
);
